import axios from "axios";
import store from "@/store";

const options = {
  baseURL: process.env.VUE_APP_API_URL,
  withCredentials: true,
  timeout: 120 * 1000,
};

const instance = axios.create(options);

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    store.commit("incrementLoadingCount");
    return config;
  },
  function (error) {
    // Do something with request error
    store.commit("decrementLoadingCount");
    store.commit(
      "setErrorMessage",
      "Beim Aufruf des Services ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal."
    );
    store.commit("setShowErrorMessage", true);
    return Promise.reject(error);
  }
);

// Add a response interceptor
instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    // console.log("hier", response);
    store.commit("decrementLoadingCount");
    store.commit("setErrors", {});
    // if (store.state.loadingCount === 0) {
    //   store.commit("setShowLoading", false);
    // }
    if (
      !response.config.url.includes("Function=DownloadCheck") &&
      !response.config.url.includes("Function=DownloadFile") &&
      !response.config.url.includes("Function=DownloadAppointmentICalFile") &&
      !response.config.url.includes("Function=DownloadSharedRoodieCheck") &&
      !response.config.url.includes("Function=GetMessageFile") &&
      !response.data.Status
    ) {
      store.commit(
        "setErrorMessage",
        "Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es in Kürze erneut."
      );
      store.commit("setShowErrorMessage", true);
    } else if (
      response.data.Status === "Error" &&
      !response.config.url.includes("Register")
    ) {
      if (response.data.Errors) {
        if (Object.keys(response.data.Errors).length === 1) {
          store.commit(
            "setErrorMessage",
            response.data.Errors[Object.keys(response.data.Errors)[0]]
          );
        } else if (Object.keys(response.data.Errors).length > 1) {
          store.commit(
            "setErrorMessage",
            "Es ist ein Fehler aufgetreten. Bitte kontrollieren Sie alle Eingabefelder und versuchen Sie es dann noch einmal."
          );
        }
        store.commit("setErrors", response.data.Errors);
      }
      if (response.data.Errors.General) {
        store.commit("setErrorMessage", response.data.Errors.General);
      }
      store.commit("setShowErrorMessage", true);
    }
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    store.commit("decrementLoadingCount");
    store.commit(
      "setErrorMessage",
      "Das Service ist derzeit nicht erreichbar. Bitte überprüfe deine Internetverbindung oder versuche es später noch einmal."
    );
    store.commit("setShowErrorMessage", true);
    return Promise.reject(error);
  }
);
export default instance;
